import SchoolConfirmationLogin from './SchoolConfirmationLogin'

export default SchoolConfirmationLogin
